import { useMemo } from "react";
import moment from "moment-timezone";
import { ProgramPhase } from "@platform/types/platform.types";
import getUserMeetingRoleFromMeeting from "@platform/utils/getUserMeetingRoleFromMeeting";
import { usePlatform } from "@platform/PlatformContext";
import { useProgram } from "../../hooks/useProgram";
import { ProgramPhaseItem } from "./ProgramPhaseItem";
import { useDialog } from "@shared/features/dialog/useDialog";

type Props = {
  phase: ProgramPhase;
  currentPhase: ProgramPhase;
  isLoading: boolean;
};

export function ProgramPhaseItemContainer({
  phase,
  currentPhase,
  isLoading,
}: Props) {
  const { user } = usePlatform();

  const { openDialog } = useDialog();

  const { program } = useProgram();

  const meetingAction = phase.actions?.find(
    (action) => action.type === "meeting"
  );

  const meeting = meetingAction?.binding_object_data;

  const role = getUserMeetingRoleFromMeeting(meeting, user?.id || null);

  const isPhaseInScheduledEngagement = useMemo(() => {
    return (
      program?.scheduled_engagement_start_date &&
      program?.scheduled_engagement_end_date &&
      moment(phase.start_date).isSameOrAfter(
        program.scheduled_engagement_start_date
      ) &&
      moment(phase.end_date).isSameOrBefore(
        program.scheduled_engagement_end_date
      )
    );
  }, [
    program?.scheduled_engagement_start_date,
    program?.scheduled_engagement_end_date,
    phase.start_date,
    phase.end_date,
  ]);

  const handleMeetingInformationClick = () => {
    openDialog("meetingInformation", {
      meetingId: meeting?.id,
    });
  };

  return (
    <ProgramPhaseItem
      phase={phase}
      currentPhase={currentPhase}
      isLoading={isLoading}
      role={role}
      isPhaseInScheduledEngagement={isPhaseInScheduledEngagement || false}
      onMeetingInformationClick={handleMeetingInformationClick}
    />
  );
}

export default ProgramPhaseItem;
